// extracted by css-extract-rspack-plugin
export default {"baseBox":"baseBox-VBuQA_"};